#import "../fragments/text-automation-fragment.graphql"

mutation CreateTextAutomation($textAutomation: TextAutomationCreateInput!) {
    textAutomationCreate(input: $textAutomation) {
        textAutomation {
            ...TextAutomation
        }
    }
}
